import React from 'react';

import Logo from "../../../assets/images/logo.png"

export default (props: any) => <img {...props} src={Logo} alt="logo" />